import { getToken } from "src/redux/selectors";

export function addPexunit(values, activateDisplayId) {
  if (activateDisplayId) {
    values.activateDisplayId = true;
  }
  return (dispatch) =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER + "mtgroup/api/pexunit/addpexunit",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify(values),
        }
      ).then(async (res) => {
        if (!res.ok) {
          return reject({ message: "Failed to add pexunit" });
        }
        return resolve(await res.text());
      });
    }).catch((err) => {
      throw err.message;
    });
}

export function savePexunit(values, activateDisplayId) {
  if (activateDisplayId) {
    values.activateDisplayId = true;
  }
  return (dispatch) =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER + "mtgroup/api/pexunit/savepexunit",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify(values),
        }
      ).then(async (res) => {
        if (!res.ok) {
          return reject({ message: "Failed to edit pexunit" });
        }
        return resolve(await res.text());
      });
    }).catch((err) => {
      throw err.message;
    });
}

export function deletePexunit(id) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          "mtgroup/api/pexunit/deletepexunit",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify({ id: id }),
        }
      )
        .then((res) => {
          if (!res.ok) {
            return reject({ message: "Failed to delete pexunit" });
          }
          res.text();
        })
        .catch(async (error) => {
          return reject(error);
        })
        .then(async (response) => {
          try {
            return resolve({ message: response });
          } catch (e) {
            return reject({ message: response });
          }
        });
    }).catch((err) => {
      throw err.message;
    });
}

export function findAllPexunit() {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          "mtgroup/api/pexunit/findallpexunit",
        {
          method: "GET",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      ).then(async (res) => {
        if (!res.ok) {
          return reject({ message: await res.text() });
        }
        return resolve(
          dispatch({
            type: "PEXUNIT_FIND_ALLPEXUNIT",
            data: await res.json(),
          })
        );
      });
    }).catch((err) => {
      throw err.message;
    });
}

export function findMyPexunit(make) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          "mtgroup/api/pexunit/findmypexunit",
        {
          method: "GET",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
        .then((res) => res.text())
        .catch(async (error) => {
          return reject(error);
        })
        .then(async (response) => {
          try {
            const parsedResponse = JSON.parse(response);
            return resolve(
              dispatch({
                type: "VEHICLES_FIND_MYVEHICLES",
                data: parsedResponse,
              })
            );
          } catch (e) {
            return reject({ message: response });
          }
        });
    }).catch((err) => {
      throw err.message;
    });
}

export function findJobNumbers(value) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          "mtgroup/api/pexunit/getjobnumbers?value=" +
          value,
        {
          method: "GET",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      ).then(async (res) => {
        if (!res.ok) {
          return reject({ message: "Failed to get job numbers" });
        }
        return resolve(await res.json());
      });
    }).catch((err) => {
      throw err.message;
    });
}

export function findPexunitDetails(id) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          "mtgroup/api/pexunit/findpexunitdetails?id=" +
          id,
        {
          method: "GET",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
        .then((res) => res.text())
        .catch(async (error) => {
          return reject(error);
        })
        .then(async (response) => {
          try {
            const parsedResponse = JSON.parse(response);
            return resolve(
              dispatch({
                type: "VEHICLES_FIND_VEHICLEDETAILS",
                data: parsedResponse,
              })
            );
          } catch (e) {
            return reject({ message: response });
          }
        });
    }).catch((err) => {
      throw err.message;
    });
}

export function findAuctionPexunit() {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          "mtgroup/api/pexunit/findauctionpexunit",
        {
          method: "GET",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      ).then(async (res) => {
        if (!res.ok) {
          return reject({ message: await res.text() });
        }
        return resolve(
          dispatch({
            type: "VEHICLES_FIND_AUCTIONVEHICLES",
            data: await res.json(),
          })
        );
      });
    }).catch((err) => {
      throw err.message;
    });
}

export function findDealDonePexunit() {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          "mtgroup/api/pexunit/finddealdonepexunit",
        {
          method: "GET",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      ).then(async (res) => {
        if (!res.ok) {
          return reject({ message: await res.text() });
        }
        return resolve(
          dispatch({
            type: "VEHICLES_FIND_DEALDONEVEHICLES",
            data: await res.json(),
          })
        );
      });
    }).catch((err) => {
      throw err.message;
    });
}

export function findAuctionWonPexunit() {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          "mtgroup/api/pexunit/findauctionwonpexunit",
        {
          method: "GET",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      ).then(async (res) => {
        if (!res.ok) {
          return reject({ message: await res.text() });
        }
        return resolve(
          dispatch({
            type: "VEHICLES_FIND_WONVEHICLES",
            data: await res.json(),
          })
        );
      });
    }).catch((err) => {
      throw err.message;
    });
}

export function findAuctionLostPexunit() {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          "mtgroup/api/pexunit/findauctionlostpexunit",
        {
          method: "GET",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      ).then(async (res) => {
        if (!res.ok) {
          return reject({ message: await res.text() });
        }
        return resolve(
          dispatch({
            type: "VEHICLES_FIND_LOSTVEHICLES",
            data: await res.json(),
          })
        );
      });
    }).catch((err) => {
      throw err.message;
    });
}

export function setEditPexunit(pexunit) {
  return (dispatch) =>
    dispatch({
      type: "VEHICLES_SET_EDITVEHICLE",
      data: pexunit,
    });
}

export function setPexunitDetailsId(id) {
  return (dispatch) =>
    dispatch({
      type: "VEHICLES_SET_VEHICLEDETAILSID",
      data: id,
    });
}

export function findVariants(model) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          "mtgroup/api/cddata/findvariants?model=" +
          model,
        {
          method: "GET",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
        .then((res) => res.text())
        .catch(async (error) => {
          return reject(error);
        })
        .then(async (response) => {
          try {
            const parsedResponse = JSON.parse(response);
            return resolve(
              dispatch({
                type: "CDDATA_FIND_VARIANTS",
                data: parsedResponse,
              })
            );
          } catch (e) {
            return reject({ message: response });
          }
        });
    }).catch((err) => {
      throw err.message;
    });
}

export function findYears(variant) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          "mtgroup/api/cddata/findyears?variant=" +
          variant,
        {
          method: "GET",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
        .then((res) => res.text())
        .catch(async (error) => {
          return reject(error);
        })
        .then(async (response) => {
          try {
            const parsedResponse = JSON.parse(response);
            return resolve(
              dispatch({
                type: "CDDATA_FIND_YEARS",
                data: parsedResponse,
              })
            );
          } catch (e) {
            return reject({ message: response });
          }
        });
    }).catch((err) => {
      throw err.message;
    });
}

export function acceptOffer(id) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER + "mtgroup/api/pexunit/acceptoffer",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify({ id: id }),
        }
      ).then(async (res) => {
        if (!res.ok) {
          return reject({ message: "Failed to accept offer" });
        }
        return resolve(await res.text());
      });
    }).catch((err) => {
      throw err.message;
    });
}

export function rejectOffer(id) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER + "mtgroup/api/pexunit/rejectoffer",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify({ id: id }),
        }
      ).then(async (res) => {
        if (!res.ok) {
          return reject({ message: "Failed to reject offer" });
        }
        return resolve(await res.text());
      });
    }).catch((err) => {
      throw err.message;
    });
}

export function acceptAdminOffer(id) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          "mtgroup/api/pexunit/acceptadminoffer",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify({ id: id }),
        }
      ).then(async (res) => {
        if (!res.ok) {
          return reject({ message: "Failed to accept offer" });
        }
        return resolve(await res.text());
      });
    }).catch((err) => {
      throw err.message;
    });
}

export function rejectAdminOffer(id) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER +
          "mtgroup/api/pexunit/rejectadminoffer",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify({ id: id }),
        }
      ).then(async (res) => {
        if (!res.ok) {
          return reject({ message: "Failed to reject offer" });
        }
        return resolve(await res.text());
      });
    }).catch((err) => {
      throw err.message;
    });
}
